import EventsService from 'app/services/events/events.service';
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import LayoutsService from 'external-services/layouts-service/layouts.service';
import GridSyncService from 'app/services/gridSync/gridSync.service';
import PouchActions, {PouchDocType} from 'app/actions/pouch.actions';

const NS = 'LayoutsCtrl';

export default function LayoutsCtrl(
  $mdDialog, $log, $state, $rootScope, $window,
  tablesService, scheduleService
) {
  "ngInject";

  const vm = this;
  //-- define public methods
  vm.edit = edit;
  vm.newLayout = newLayout;
  vm.showPlan = $window.config.plan.layout;
  vm.duplicateLayout = duplicateLayout;
  vm.deleteLayout = deleteLayout;

  // $rootScope.$on('pouch-synced-doctype-layout', getSectionsLookUp);
  PouchActions.handlePouchSyncedDoctype(PouchDocType.layout, () => getSectionsLookUp());

  getSectionsLookUp();

  function getSectionsLookUp() {
    SectionLookupService.getSectionsLookUp().then(function (sections) {
      vm.sectionsLookup = sections;
      getLayouts();
    }).catch(function (err) {
      $log.error('error getSectionsLookUp', err);
    });
  }

  function getLayouts() {
    LayoutsService.getAllLayouts().then(function (layouts) {
      for (var i = layouts.length - 1; i >= 0; i--) {
        var layout = layouts[i];
        layout.section = vm.sectionsLookup[layout.sectionId];
      }
      vm.layouts = layouts;
    }).catch(function (err) {
      $log.error('faild to load layouts', err);
    });
  }

  function edit(evt, layout) {
    $state.go('settings.layouts.edit', {
      id: encodeURIComponent(layout._id)
    });
  }

  function newLayout() {
    $state.go('settings.layouts.new');
  }

  function duplicateLayout(evt, layout) {
    $state.go('settings.layouts.duplicate', {
      id: encodeURIComponent(layout._id)
    });
  }

  function deleteLayout(evt, layout) {
    var schedulesList;
    scheduleService.getDaySchedules().then(function (schedules) {
      schedulesList = schedules;
      return EventsService.getEventsFromDate();
    }).then(function (events) {
      var inUseList = layoutInUse(layout, schedulesList, events);
      if (inUseList.length) {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title('Delete Failed')
            .htmlContent('This layout is in use. Please remove it from all your schedules and events before deleting.<br><br>It\'s used in the following places:<br>- ' + inUseList.join('<br>- '))
            .ariaLabel('Delete Failed')
            .ok('OK')
            .targetEvent(evt)
        );
      } else {
        var confirm = $mdDialog.confirm()
          .parent(angular.element(document.body))
          .title('Are you sure?')
          .htmlContent('Delete layout ' + layout.name)
          .ariaLabel('Delete layout')
          .ok('Yes')
          .cancel('No')
          .targetEvent(evt);
        $mdDialog.show(confirm).then(function () {
          var deletedLayoutId = layout._id;
          tablesService.deteleLayout(layout).then(function () {
            // CLI-165: notify the Grid Sync API of the deletion
            GridSyncService.layoutDeleted(deletedLayoutId);
          });
        });
      }
    });
  }

  function layoutInUse(layout, schedules, events) {
    var layoutParts = layout._id.split('_');
    var layoutId = layoutParts[0] + '_' + layoutParts[1];
    var inUseList = [];
    var sectionLayout;

    for (var i = schedules.length - 1; i >= 0; i--) {
      var schedule = schedules[i];
      var inUseInSchedule = false;
      for (var s = schedule.services.length - 1; s >= 0; s--) {
        var service = schedule.services[s];
        for (var l = service.sectionLayouts.length - 1; l >= 0; l--) {
          sectionLayout = service.sectionLayouts[l];
          if (layoutId === sectionLayout.layoutId) {
            inUseList.push('Schedule for ' + schedule.dayName);
            inUseInSchedule = true;
            break;
          }
        }
        if (inUseInSchedule) {
          break;
        }
      }
    }

    for (var e = events.length - 1; e >= 0; e--) {
      var eventObj = events[e];
      for (var sl = eventObj.sectionLayouts.length - 1; sl >= 0; sl--) {
        sectionLayout = eventObj.sectionLayouts[sl];
        if (layoutId === sectionLayout.layoutId) {
          inUseList.push('Event for ' + eventObj.name);
        }
      }
    }

    return inUseList;
  }
}
